/**
 * Every string a fan reads in the web onboarding container and its steps.
 * These strings are pinned by `onboardingCopy` assertions inside the
 * step tests, and a reword is a deliberate act.
 */

export const USERNAME_HEADLINE = "Pick a username";
export const USERNAME_SUB = "This is the name other players see in your pools.";
export const USERNAME_LABEL = "Username";
export const USERNAME_PLACEHOLDER = "yourname";
export const USERNAME_CHECKING_LABEL = "Checking availability";
export const USERNAME_CLAIMED_HINT =
  "You already picked this one. You can change it later in settings.";

export const ABOUT_YOU_HEADLINE = "A little about you";
export const ABOUT_YOU_SUB =
  "Pools run among people who know each other. A real name helps.";
export const ONBOARDING_LAST_NAME_LABEL = "Last name (optional)";
export const ONBOARDING_PHONE_LABEL = "Phone number (optional)";
export const BIRTHDAY_AGE_HINT = "You have to be 13 or older to use Sportsmet.";
export const EMAIL_LABEL = "Email";
export const EMAIL_HINT =
  "From your sign-in. You can change it later in settings.";

export const CONTINUE_LABEL = "Continue";
export const CONTINUE_PENDING_LABEL = "Saving";

export const UNDER_AGE_HEADLINE = "You have to be 13 or older";
export const UNDER_AGE_BODY =
  "We can't let you use Sportsmet under 13. If you confirm, we'll delete your account. There's nothing to undo after that.";
export const UNDER_AGE_DELETE_LABEL = "Delete account";
export const UNDER_AGE_DELETE_PENDING_LABEL = "Deleting account";
export const UNDER_AGE_CANCEL_LABEL = "Cancel";

export const SIGN_IN_METHODS_HEADLINE = "Add another way to sign in";
export const SIGN_IN_METHODS_SUB =
  "Next time you can tap once instead of waiting for an email.";
export const SIGN_IN_METHODS_ADD_EMAIL_LABEL = "Add an email address";
export const SIGN_IN_METHODS_ADDED_LABEL = "Added";
export const SIGN_IN_METHODS_EMAIL_HELP =
  "Adding an email sends a sign-in code to it, the same as signing in.";

export function signInMethodConflictMessage(
  provider: "apple" | "google",
): string {
  if (provider === "apple") {
    return "That Apple ID already signs in to a different Sportsmet account.";
  }
  return "That Google account already signs in to a different Sportsmet account.";
}

export const SPORTS_HEADLINE = "Which sports do you follow?";
export const SPORTS_GRID_LABEL = "Sports you follow";
export const LEAGUES_HEADLINE = "Which leagues do you follow?";
export const LEAGUES_SUB = "We'll put these at the top of your scores.";
export const LEAGUES_GROUP_HELP = "Pick none and we'll show you all of them.";
export const LEAGUES_GROUP_LABEL_SUFFIX = "leagues";
export const ONBOARDING_SKIP_LABEL = "Skip";

export const PHOTO_HEADLINE = "Add a photo";
export const PHOTO_UPLOAD_LABEL = "Upload a photo";
export const PHOTO_CHANGE_LABEL = "Change photo";
export const PHOTO_UPLOAD_FAILED_MESSAGE =
  "That photo didn't upload. Try another one.";
export const PHOTO_PENDING_REVIEW_MESSAGE =
  "We're still checking that photo. Your initials stay up until it's ready.";

export function usernameTakenMessage(username: string): string {
  return `@${username} is taken`;
}

export function usernameFreeMessage(username: string): string {
  return `@${username} is free`;
}

export function stepIndicatorLabel(index: number, total: number): string {
  return `Step ${index} of ${total}`;
}
